<template>
  <button
    :disabled="disabled"
    :type="type"
    @click="onClick"
    :style="getStyle()"
  >
    {{slotAfter ? value : ''}}
    <slot />
    {{!slotAfter ? value : ''}}
  </button>
</template>

<script>
export default {
  name: 'app-button',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    slotAfter: {
      type: Boolean,
    },
    href: {
      type: String,
    },
    color: {
      type: String,
      default: '',
    },
  },
  methods: {
    getStyle() {
      const style = {};
      if (this.color !== '') {
        if (this.color === 'primary') {
          style['background-color'] = '#36A3CA';
        } else {
          style['background-color'] = this.color;
        }
      }
      return style;
    },
    onClick(value) {
      if (this.href) {
        window.location.href = this.href;
      }
      this.$emit('click', value);
    },
  },
};
</script>
